var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconViewTestResults(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "A-B-testing",
    transform: "translate(-680.000000, -1356.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-view-test-results",
    transform: "translate(680.000000, 1356.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.4,5.46 C1.19,5.46 0.98,5.32 0.91,5.18 C0.77,4.9 0.84,4.55 1.12,4.41 L5.32,2.31 C5.46,2.24 5.67,2.24 5.81,2.31 L9.66,4.2 L12.18,1.05 C12.39,0.84 12.74,0.77 12.95,0.98 C13.16,1.19 13.23,1.54 13.02,1.75 L10.22,5.25 C10.08,5.46 9.8,5.53 9.52,5.39 L5.6,3.43 L1.68,5.39 C1.54,5.46 1.47,5.46 1.4,5.46 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 1.4,
    cy: 4.9,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 5.6,
    cy: 2.8,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 9.8,
    cy: 4.9,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 12.6,
    cy: 1.4,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 12.6,
    cy: 9.1,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 9.8,
    cy: 12.6,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 6.3,
    cy: 9.8,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 1.4,
    cy: 11.2,
    r: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.8,13.16 C9.66,13.16 9.52,13.09 9.45,13.02 L6.16,10.43 L1.54,11.76 C1.26,11.83 0.91,11.69 0.84,11.41 C0.77,11.13 0.91,10.78 1.19,10.71 L6.09,9.31 C6.3,9.24 6.44,9.31 6.58,9.38 L9.66,11.83 L12.04,8.75 C12.25,8.54 12.6,8.47 12.81,8.68 C13.02,8.89 13.09,9.24 12.88,9.45 L10.15,12.95 C10.15,13.09 10.01,13.16 9.8,13.16 C9.87,13.16 9.8,13.16 9.8,13.16 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconViewTestResults);
export default __webpack_public_path__ + "static/media/icon-view-test-results.e389581f8ad3fb55cc9691aee0bce31b.svg";
export { ForwardRef as ReactComponent };